import React, { useContext } from "react";
import { IonLabel, IonIcon, IonItem } from "@ionic/react";
import { warningOutline } from "ionicons/icons";
import { TranslationsContext } from "../util/Translations";
import { useTestEnvironmentStore } from "../store/test-environment";

// US 874329: Test/Training banner. Mirrors the EAM web banner
// (EamTestEnvBanner) — shown when the current plant is flagged as a
// test/training environment (sy_registration.test_train_flag). Rendered as a
// header strip alongside OnlineStatus. The store flag is populated in
// AppTabs after the user session settings load.
const TestEnvBanner: React.FC = () => {
  const { translations } = useContext(TranslationsContext);

  const isTestEnvironment = useTestEnvironmentStore(
    (state) => state.isTestEnvironment
  );

  return (
    <IonItem
      hidden={!isTestEnvironment}
      className="eam-test-env-banner"
      lines="none"
    >
      <IonIcon icon={warningOutline} slot="start" aria-hidden="true" />
      <IonLabel className="ion-text-wrap ion-text-center">
        {translations["eam_test_env_banner_text"] ||
          "TEST ENVIRONMENT – Data entered here is not live"}
      </IonLabel>
    </IonItem>
  );
};

export default TestEnvBanner;
